// extracted by mini-css-extract-plugin
export default {"mainTab":"GraphTab_mainTab__Fkw5L"};